/* this file is transformed by vux-loader */
/* eslint-disable */
import base from '../base';
import http from '../http';
var Dict = {
  getDictInfo: function getDictInfo(params) {
    return http.post("".concat(base.dev, "/dictInfo/selectListByEntity"), params);
  }
};
export default Dict;